import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button/button.component';

@Component({
  selector: 'assign-aircraft-confirmation-modal',
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ButtonComponent,
    TranslateModule,
  ],
  templateUrl: './assign-aircraft-confirmation-modal.component.html',
  styleUrl: './assign-aircraft-confirmation-modal.component.scss',
})
export class AssignAircraftConfirmationModalComponent {
  constructor(
    public dialogRef: MatDialogRef<AssignAircraftConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      validCount: number;
      invalidCount: number;
      companyName: string;
    },
  ) {}

  confirm(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
